import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const View24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9988 5.0008C8.14789 4.94755 4.44094 7.56777 2.23165 9.99958L2.22737 10.0043C1.75912 10.5242 1.5 11.199 1.5 11.8986C1.5 12.5983 1.75911 13.2731 2.22736 13.793L2.23134 13.7974C4.38873 16.1735 8.08679 18.853 11.9988 18.7989C15.9107 18.853 19.6095 16.1736 21.7683 13.7978L21.7726 13.793C22.2409 13.2731 22.5 12.5983 22.5 11.8986C22.5 11.199 22.2409 10.5241 21.7726 10.0043L21.7678 9.99895C19.5566 7.56781 15.8497 4.94755 11.9988 5.0008ZM20.6581 12.789C18.6053 15.0483 15.2788 17.3539 11.9988 17.2987C8.71876 17.3539 5.39312 15.0483 3.34189 12.789C3.1218 12.5447 3 12.2275 3 11.8986C3 11.5698 3.1218 11.2526 3.34189 11.0082C5.43872 8.7002 8.77396 6.44657 11.9988 6.50097C15.2236 6.44657 18.5589 8.7002 20.6581 11.0082C20.8782 11.2526 21 11.5698 21 11.8986C21 12.2275 20.8782 12.5447 20.6581 12.789ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
